
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-map/[councilCode]",
      function () {
        return require("private-next-pages/planning-map/[councilCode].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-map/[councilCode]"])
      });
    }
  